// client/src/pages/ShopSuspended.tsx

import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, LogOut, Clock } from "lucide-react";
import { useLocation } from "wouter";

export default function ShopSuspended() {
  const [, setLocation] = useLocation();
  const [secondsLeft, setSecondsLeft] = useState(5);

  useEffect(() => {
    // Limpiar localStorage al cargar esta página
    localStorage.removeItem("currentShop");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("currentOwner");
    localStorage.removeItem("ownerShops");
    localStorage.removeItem("activeShopId");
    localStorage.removeItem("shopOwner");
    localStorage.removeItem("activeShop");

    // Contador regresivo
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setLocation("/shop/login");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [setLocation]);

  const handleManualRedirect = () => {
    setLocation("/shop/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      {/* No hay Navbar aquí porque no hay sesión activa */}
      <Card className="w-full max-w-md shadow-2xl border-destructive/20">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <AlertCircle className="w-10 h-10 text-destructive" />
          </div>
          <CardTitle className="text-2xl font-bold text-destructive">
            Cuenta Suspendida
          </CardTitle>
        </CardHeader>

        <CardContent className="space-y-6">
          <p className="text-center text-muted-foreground">
            La cuenta del propietario ha sido suspendida. No puedes acceder a
            las funcionalidades del sistema.
          </p>

          <div className="bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-lg p-4 space-y-2">
            <h4 className="font-semibold text-amber-800 dark:text-amber-400">
              ¿Qué puedes hacer?
            </h4>
            <ul className="text-sm text-amber-700 dark:text-amber-300 space-y-1 list-disc list-inside">
              <li>Contacta al propietario para regularizar el pago</li>
              <li>Verifica el estado de la suscripción</li>
              <li>Comunícate con el administrador del sistema</li>
            </ul>
          </div>

          <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-4 space-y-1">
            <p className="text-sm font-medium">Información de contacto:</p>
            <p className="text-sm text-muted-foreground">
              Email: fm.izquierdo@nauta.cu
            </p>
            <p className="text-sm text-muted-foreground">
              Teléfono: +53 54882577
            </p>
            <p className="text-sm text-muted-foreground">
              Horario: Lunes a Domingo, 9:00 AM - 5:00 PM
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <Button
              onClick={handleManualRedirect}
              className="w-full h-12 text-base font-semibold"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Ir al Login
            </Button>

            <p className="text-center text-sm text-muted-foreground flex items-center justify-center gap-1">
              <Clock className="h-3 w-3" />
              Redirección automática en {secondsLeft} segundos
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
